var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v("\n  Copyright Reserved 2000-2013 雅昌艺术网 版权所有\n")])}
var staticRenderFns = []

export { render, staticRenderFns }